import { api } from "../api";
const defaultRouteName = "/acfaz/videoconferencia/";

export const entrarVideoconferenciaAgr = (data) =>
  api.post(`${defaultRouteName}sessao/agr`, data);

export const entrarVideoconferenciaCliente = (data) =>
  api.post(`${defaultRouteName}sessao/cliente`, data);

export const iniciarGravacaoVideoconferencia = (data) =>
  api.post(`${defaultRouteName}gravacao/iniciar`, data);

export const finalizarGravacaoVideoconferencia = (data) =>
  api.post(`${defaultRouteName}gravacao/finalizar`, data);

export const TipoPendenciaColetaPrevia = {
  Selfie: "SELFIE_PREVIA",
  DocumentoIdentificacao: "DOC_IDENTIFICACAO_PREVIA",
};

export const TipoPendenciaValidador = {
  Selfie: "SELFIE_PREVIA",
  FotoDocumento: "FOTO_DOCUMENTO_PREVIA",
};

export const enviarColetaPrevia = async ({
  idSolicitacao,
  cpf,
  tipoPendencia,
  documentoBase64,
}) => {
  const response = await api.post(
    `${defaultRouteName}coleta-previa`,
    { idSolicitacao, tipoPendencia, documentoBase64 },
    { params: { cpf } },
  );

  return response.data;
};

export const verificaDocumentosColetaPrevia = async ({ idSolicitacao }) => {
  const response = await api.get(
    `${defaultRouteName}coleta-previa/${idSolicitacao}/status`,
  );

  return response.data;
};
